(function () {
  function initFeaturedCarousel() {
    var grid = document.querySelector('.featured-grid:not(.featured-grid--recent)');
    if (!grid) return;

    var track = grid.querySelector('.featured-grid__items');
    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.featured-card--glass'));
    if (cards.length < 2) return;

    // Build dots container
    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'carousel-dots';

    cards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'carousel-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        var targetCard = cards[i];
        track.scrollTo({
          left: targetCard.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });
      });
      dotsContainer.appendChild(dot);
    });

    grid.appendChild(dotsContainer);

    // Update active dot on scroll
    var dots = dotsContainer.querySelectorAll('.carousel-dot');
    var scrollTimer;

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var scrollLeft = track.scrollLeft;
        var closest = 0;
        var minDist = Infinity;

        cards.forEach(function (card, i) {
          var dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === closest);
        });
      }, 60);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCarousel);
  } else {
    initFeaturedCarousel();
  }
})();
